// extracted by mini-css-extract-plugin
module.exports = {"contentBody":"contentBody--3Kmx-"};